import React from 'react';

import DropDown from '../../../Reutilizaveis/DropDown';

import './styles.scss';

const Calendario = ({
  errorMsgAgendamento,
  erroHorarioNaoDisponivel,
  setDataParaAgendar,
  diasDisponiveis,
}) => {
  return (
    <div
      className='agendamentoSolicitacao__agendar'
      style={{ marginTop: '60px' }}
    >
      <DropDown
        itens={diasDisponiveis}
        idDropDown={'listaSDiasDisponiveisAgendamento'}
        setValue={setDataParaAgendar}
        label='Qual a melhor data para o seu atendimento?'
        nomeDropDown={'Data'}
        obrigatorio='true'
        error={errorMsgAgendamento || erroHorarioNaoDisponivel}
        widthMeuImovel='100%'
        marginLeftMeuImovel='0px'
        btnClose={false}
      />
    </div>
  );
};

export default Calendario;
